import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; 
import './style.css';

const TextEditor = ({ field, form, readonly = false }) => {
  const [editorContent, setEditorContent] = useState(field.value || '');

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], 
      ['bold', 'italic', 'underline', 'strike'], 
      [{ list: 'ordered' }, { list: 'bullet' }], 
      [{ align: [] }], 
      ['link'], 
      ['clean'], 
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'align',
    'link',
  ];

  useEffect(() => {
    setEditorContent(field.value || '');
  }, [field.value]);

  const handleChange = (content) => {
    setEditorContent(content);
    form.setFieldValue(field.name, content);
  };

  return (
    <div>
      <ReactQuill
        placeholder='Enter Description'
        value={editorContent}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        className="custom-quill-editor"
        readOnly={readonly}
      />
    </div>
  );
};

export default TextEditor;
